import { render, staticRenderFns } from "./MaterialFilter.vue?vue&type=template&id=89497826&"
import script from "./MaterialFilter.vue?vue&type=script&lang=js&"
export * from "./MaterialFilter.vue?vue&type=script&lang=js&"
import style0 from "./MaterialFilter.vue?vue&type=style&index=0&id=89497826&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports